import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h

export default {
    name: 'kendo-chat-toolbar-button',
    setup() {
        const v3 = !!gh
        return {
            v3
        }
    },
    render () {
        return null
    },
    props:{
        name: {
            type: String,
            default: undefined
        },
        text: {
            type: String,
            default: undefined
        },
        iconClass: {
            type: String,
            default: undefined
        },
        attr: {
            type: Object,
            default: undefined
        }
    },
    watch: {
        $attrs () {
            this.mergeAttrs()
        }
    },
    mounted () {
        if (!this.v3) {
            this.mergeAttrs()
        }
    },
    methods: {
        mergeAttrs () {
            if(this.$options.propsData.attr){
                this.attr = Object.assign(this.attr, this.$attrs)
            } else {
                this.$options.propsData.attr = Object.assign({}, this.attr, this.$attrs)
            }
        }
    }
}



// WEBPACK FOOTER //
// ./packages/kendo-chat-vue-wrapper/src/KendoChat/KendoChatToolbarButton.js